import { getPublishedArticles, Article } from './articles'
export const generateRssFeed = async (): Promise<string> => {
  const { articles } = await getPublishedArticles(50)
  const siteUrl = window.location.origin
  const feedUrl = `${siteUrl}/rss.xml`
  const title = 'Operation Launchpad eNews'
  const description =
    'Stay updated with the latest entrepreneurial insights, success stories, and program updates.'
  // Format date for RSS
  const formatDate = (timestamp: any): string => {
    if (!timestamp) return new Date().toUTCString()
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp)
    return date.toUTCString()
  }
  // XML escaping
  const escapeXml = (unsafe: string): string => {
    return unsafe.replace(/[<>&'"]/g, (c) => {
      switch (c) {
        case '<':
          return '&lt;'
        case '>':
          return '&gt;'
        case '&':
          return '&amp;'
        case "'":
          return '&apos;'
        case '"':
          return '&quot;'
        default:
          return c
      }
    })
  }
  // Generate RSS XML
  let rss = `<?xml version="1.0" encoding="UTF-8" ?>
<rss version="2.0" xmlns:atom="http://www.w3.org/2005/Atom">
<channel>
  <title>${escapeXml(title)}</title>
  <link>${siteUrl}</link>
  <description>${escapeXml(description)}</description>
  <lastBuildDate>${formatDate(new Date())}</lastBuildDate>
  <atom:link href="${feedUrl}" rel="self" type="application/rss+xml" />`
  // Add items
  articles.forEach((article: Article) => {
    const articleUrl = `${siteUrl}/enews/${article.id}`
    const pubDate = formatDate(article.publishedAt)
    rss += `
  <item>
    <title>${escapeXml(article.title)}</title>
    <link>${articleUrl}</link>
    <guid isPermaLink="true">${articleUrl}</guid>
    <pubDate>${pubDate}</pubDate>
    <description>${escapeXml(article.excerpt)}</description>
    ${article.featuredImage ? `<enclosure url="${article.featuredImage}" type="image/jpeg" />` : ''}
    ${article.categoryName ? `<category>${escapeXml(article.categoryName)}</category>` : ''}
    ${article.tags && article.tags.map((tag) => `<category>${escapeXml(tag)}</category>`).join('')}
  </item>`
  })
  rss += `
</channel>
</rss>`
  return rss
}
